import { Alert, AlertTitle, Box } from '@mui/material';

export const Unauthorized = () => {
	return (
		<Box
			justifyContent='center'
			display='flex'>
			<Alert
				severity='error'
				sx={{ width: '50%' }}>
				<AlertTitle>Unauthorized</AlertTitle>
				You do not have the correct permissions to view this page. If
				you believe this is a mistake, please contact PQSupport.
			</Alert>
		</Box>
	);
};
